import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC } from 'react';

import { connectOrdersBasketHeaderCellComponent } from './OrdersBasketHeaderCell.connect';
import type { OrdersBasketHeaderCellProps } from './OrdersBasketHeaderCell.model';

export const OrdersBasketHeaderCellComponent: FC<OrdersBasketHeaderCellProps> = ({
  isVisible,
  fieldId,
  translationKey,
}) => {
  return isVisible ? (
    <th className="align-middle">
      <FormattedMessage id={`form.${translationKey ?? fieldId}` as IntlKey} />
    </th>
  ) : null;
};

export const OrdersBasketHeaderCell = connectOrdersBasketHeaderCellComponent(OrdersBasketHeaderCellComponent);
